<template>
  <div class="flex justify-center">
    <ul class="flex gap-x-0.5">
      <li v-if="startPage > 1">
        <button class="w-7 h-7 rounded-full bg-arrow-left text-gray-600 hover:bg-gray-200 transition"
                @click="onMovePage(startPage - 1)"
        ></button>
      </li>
      <li v-for="page in viewPages" :key="page">
        <button class="w-7 h-7 rounded-lg transition"
                :class="[
                  pageInfo?.currentPageNum === page ? 'bg-blue-400 text-white hover:bg-blue-400' : 'text-gray-600 hover:bg-gray-200'
                ]"
                @click="onMovePage(page)"
        >{{page}}</button>
      </li>
      <li v-if="endPage < pageInfo?.totalPages">
        <button class="w-7 h-7 rounded-full bg-arrow-right text-gray-600 hover:bg-gray-200 transition"
                @click="onMovePage(endPage + 1)"
        ></button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GrmPagination',
  props: {
    pageInfo: { type: Object, default: () => { return {} }, required: true },
    viewPageCnt: { type: Number, default: 10 },
  },
  computed: {
    startPage() {
      return Math.floor((this.pageInfo.currentPageNum - 1) / this.viewPageCnt) * this.viewPageCnt + 1;
    },
    endPage() {
      return Math.min(this.startPage + this.viewPageCnt - 1, this.pageInfo.totalPages);
    },
    viewPages() {
      return Array.from({ length: this.endPage - this.startPage + 1 }, (_, i) => this.startPage + i);
    },
  },
  methods: {
    onMovePage(page) {
      if (this.pageInfo.currentPageNum === page) {
        return;
      }

      this.$emit('paging', page);
    },
  }
}
</script>